// src/services/artworkService.js
import api from './api';

const getArtworks = () => {
  return api.get('artwork/artworks');
};

const getArtwork = (id) => {
  return api.get(`/artwork/artworks?art_id=${id}`);
};

const uploadArtwork = (formData) => {
  return api.post('/artwork/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const updateArtwork = (id, formData) => {
    return api.put(`artwork/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const deleteArtwork = (id) => {
    return api.delete(`artwork/delete/${id}`);
};

// Sale-related API methods
const changeArtworkStatus = (id, status) => {
  return api.put(`artwork/change-status/${id}`, { status });
};

const putArtOnSale = (id, price) => {
  return api.put(`artwork/put-art-on-sale/${id}`, { price });
};

const getArtOnSale = () => {
  return api.get('artwork/get-art-on-sale/');
};

const withdrawArtFromSale = (id) => {
  return api.put(`artwork/withdraw-art-from-sale/${id}`);
};

const getArtistDashboardStats = () => {
  return api.get('/artists/dashboard-stats');
};




const artworkService = {
  getArtworks,
  getArtwork,
  uploadArtwork,
  updateArtwork,
  deleteArtwork,
  changeArtworkStatus,
  putArtOnSale,
  getArtOnSale,
  withdrawArtFromSale,
  getArtistDashboardStats,
};

export default artworkService;
